import { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate, Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './components/Header';
import BandeauExploitation from './components/BandeauExploitation';
import BottomNav from './components/BottomNav';
import RetourEnHaut from './components/RetourEnHaut';
import DesktopNav from './components/DesktopNav';
import Home from './pages/Home';
import Evenements from './pages/Evenements';
import EvenementDetail from './pages/EvenementDetail';
import SponsorPage from './pages/SponsorPage';
import DonLibre from './pages/DonLibre';
import Association from './pages/Association';
import MonEspace from './pages/MonEspace';
import Login from './pages/Login';
import PaiementPage from './pages/PaiementPage';
import AdminParametresPage from './pages/AdminParametresPage';
import VaultPage from './pages/VaultPage';
import SauvegardesPage from './pages/SauvegardesPage';
import VersionPage from './pages/VersionPage';
import DevopsPage from './pages/DevopsPage';
import BureauDashboardPage from './pages/BureauDashboardPage';
import BureauAchatsPage from './pages/BureauAchatsPage';
import PrevisionnelAchatsPage from './pages/PrevisionnelAchatsPage';
import BilanPage from './pages/BilanPage';
import BenevolePage from './pages/BenevolePage';
import AdherentsAcces from './pages/AdherentsAcces';
import AdherentsPage from './pages/AdherentsPage';
import AdminAdherentsPage from './pages/AdminAdherentsPage';
import CotisationPage from './pages/CotisationPage';
import EncaissementsPage from './pages/EncaissementsPage';
import MonAdhesionPage from './pages/MonAdhesionPage';
import NosEquipes from './pages/NosEquipes';
import BureauMembresPage from './pages/BureauMembresPage';
import RencontresPage from './pages/RencontresPage';
import RegistreTableauPage from './pages/RegistreTableauPage';
import AdherentFichePage from './pages/AdherentFichePage';
import BureauTaillesPage from './pages/BureauTaillesPage';
import InvitationPage from './pages/InvitationPage';
import BureauFacturationPage from './pages/BureauFacturationPage';
import MotDePasseOubliePage from './pages/MotDePasseOubliePage';
import BureauEvenementsPage from './pages/BureauEvenementsPage';
import BureauEvenementDetailPage from './pages/BureauEvenementDetailPage';
import SponsorFichePage from './pages/SponsorFichePage';
import BureauArchivesPage from './pages/BureauArchivesPage';
import ExerciceCompletionPage from './pages/ExerciceCompletionPage';
import RepertoirePage from './pages/RepertoirePage';
import JourJPage from './pages/JourJPage';
import DocumentsPage from './pages/DocumentsPage';
import AdministrationPage from './pages/AdministrationPage';
import GestionDroitsPage from './pages/GestionDroitsPage';
import JournalActionsPage from './pages/JournalActionsPage';
import DiffusionPage from './pages/DiffusionPage';
import CampagnePage from './pages/CampagnePage';
import FestivalPage from './pages/FestivalPage';
import GardeOption from './components/GardeOption';
import AssurancePage from './pages/AssurancePage';
import ProgrammeFestivalPage from './pages/ProgrammeFestivalPage';
import ModelesMessagePage from './pages/ModelesMessagePage';
import DonneesPersonnellesPage from './pages/DonneesPersonnellesPage';
import FournisseursPage from './pages/FournisseursPage';
import DocumentationPage from './pages/DocumentationPage';
import FichiersPage from './pages/FichiersPage';
import BureauReunionsPage from './pages/BureauReunionsPage';
import RetraitRepasPage from './pages/RetraitRepasPage';
import AccesRapide from './pages/AccesRapide';
import MessageriePage from './pages/MessageriePage';
import BoutiquePage from './pages/BoutiquePage';
import BureauBoutiquePage from './pages/BureauBoutiquePage';
import AdminBoutiquePage from './pages/AdminBoutiquePage';
import NosSponsors from './pages/NosSponsors';
import ControleVisuel from './pages/ControleVisuel';
import RubanDemo from './components/RubanDemo';
import { usePersonnalisation } from './hooks/usePersonnalisation';
import { VERSION } from './version';

const pageTransition = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -16 },
  transition: { duration: 0.25 },
};

/**
 * Ancienne adresse de l'écran des membres, conservée le temps que les signets
 * s'oublient.
 *
 * La chaîne de requête est reportée : le raccourci « Bureau » de l'accès
 * rapide porte `?filtre=bureau`, et le perdre en chemin ouvrirait la liste
 * complète — le contraire de ce qu'on a demandé.
 */
function RedirectionMembres() {
  const { search } = useLocation();

  return <Navigate to={{ pathname: '/bureau/membres', search }} replace />;
}

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        {...pageTransition}
            // En colonne et a hauteur pleine : la signature du pied se cale au
            // bas de l'ecran meme quand la page est courte, au lieu de flotter
            // juste sous le contenu, au milieu de la fenetre.
            //
            // Sans overflow-y-auto : ce conteneur ne defilait pas — mesure au
            // navigateur, il ne debordait jamais — mais il servait de reference
            // aux blocs collants, qui partaient donc avec la page.
        className="flex-1 flex flex-col min-h-full"
      >
        <div className="flex-1">
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/evenements" element={<Evenements />} />
          {/* Le programme public du festival : la page du festivalier, sans compte. */}
          <Route path="/festival/:slug" element={<ProgrammeFestivalPage />} />
          <Route path="/evenements/:id" element={<EvenementDetail />} />
          <Route path="/nos-sponsors" element={<NosSponsors />} />
          {/* Liens du courriel de controle : le jeton vaut autorisation. */}
          <Route path="/visuel/:jeton" element={<ControleVisuel />} />
          <Route path="/visuel/:jeton/:decision" element={<ControleVisuel />} />
          <Route path="/sponsors" element={<SponsorPage />} />
          <Route path="/sponsors/:id" element={<SponsorFichePage />} />
          <Route path="/don-libre" element={<DonLibre />} />
          <Route path="/association" element={<Association />} />
          <Route path="/informations" element={<MonEspace />} />
          <Route path="/mon-espace" element={<Navigate to="/informations" replace />} />
          <Route path="/acces-rapide" element={<AccesRapide />} />
          <Route path="/messagerie" element={<MessageriePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invitation/:token" element={<InvitationPage />} />
          <Route path="/mot-de-passe-oublie" element={<MotDePasseOubliePage />} />
          <Route path="/mot-de-passe-oublie/:token" element={<MotDePasseOubliePage />} />
          <Route path="/paiement/:token" element={<PaiementPage />} />
          {/* Le lien de reglement d'une cotisation : la famille l'ouvre sans compte. */}
          <Route path="/cotisation/:reference" element={<CotisationPage />} />
          <Route path="/admin/vault" element={<GardeOption option="vault" nom="Coffre-fort"><VaultPage /></GardeOption>} />
          <Route path="/admin/parametres" element={<AdminParametresPage />} />
          <Route path="/admin/sauvegardes" element={<SauvegardesPage />} />
          <Route path="/admin/version" element={<VersionPage />} />
          {/* Les ecrans d'administration reunis en cartes : le telephone n'a
              pas de menu lateral, ils y etaient introuvables. */}
          <Route path="/administration" element={<AdministrationPage />} />
          <Route path="/admin/droits" element={<GestionDroitsPage />} />
          {/* Qui a fait quoi des donnees des personnes. */}
          <Route path="/admin/journal" element={<JournalActionsPage />} />
          {/* Combien de temps on garde, et comment on efface quelqu'un qui le demande. */}
          <Route path="/admin/donnees" element={<DonneesPersonnellesPage />} />
          {/* Ce qui occupe le quota, et comment en reprendre. */}
          <Route path="/admin/fichiers" element={<FichiersPage />} />
          <Route path="/admin/devops" element={<DevopsPage />} />
          <Route path="/bureau/tableau-de-bord" element={<BureauDashboardPage />} />
          <Route path="/bureau/achats" element={<GardeOption option="achats" nom="Suivi des achats"><BureauAchatsPage /></GardeOption>} />
          <Route path="/bureau/achats/previsionnel" element={<GardeOption option="achats" nom="Suivi des achats"><PrevisionnelAchatsPage /></GardeOption>} />
          <Route path="/bureau/bilan" element={<BilanPage />} />
          <Route path="/bureau/membres" element={<BureauMembresPage />} />
          <Route path="/bureau/membres/tailles" element={<BureauTaillesPage />} />
          {/* Le registre a sa propre section de menu : ses adresses ne
              passent plus par /bureau, qui designe le bureau de l'association. */}
          {/* L'espace d'une famille : ouvert a tout compte, il ne montre
              que les adhesions qui le concernent. */}
          <Route path="/mon-adhesion" element={<MonAdhesionPage />} />
          {/* La vitrine des équipes : publique, et fermée par défaut. */}
          <Route path="/nos-equipes" element={<NosEquipes />} />
          {/*
            Le sommaire du registre : il n'a de sens que sur téléphone, où il
            n'y a pas de barre latérale pour déplier les six écrans. La route
            existe partout — une adresse qui répond ailleurs ne coûte rien, et
            un lien partagé ne doit pas tomber sur une erreur —, mais seule la
            mise en page mobile y mène.
          */}
          <Route path="/adherents/acces" element={<GardeOption option="licences" nom="Adhérents"><AdherentsAcces /></GardeOption>} />
          <Route path="/adherents" element={<GardeOption option="licences" nom="Adhérents"><AdherentsPage onglet="repertoire" /></GardeOption>} />
          <Route path="/adherents/cotisations" element={<GardeOption option="licences" nom="Adhérents"><AdherentsPage onglet="cotisations" /></GardeOption>} />
          <Route path="/adherents/equipements" element={<GardeOption option="licences" nom="Adhérents"><AdherentsPage onglet="equipements" /></GardeOption>} />
          <Route path="/adherents/equipes" element={<GardeOption option="licences" nom="Adhérents"><AdherentsPage onglet="equipes" /></GardeOption>} />
          <Route path="/adherents/tableau-de-bord" element={<GardeOption option="licences" nom="Adhérents"><RegistreTableauPage /></GardeOption>} />
          <Route path="/adherents/rencontres" element={<GardeOption option="licences" nom="Adhérents"><RencontresPage /></GardeOption>} />
          <Route path="/adherents/:id" element={<GardeOption option="licences" nom="Adhérents"><AdherentFichePage /></GardeOption>} />
          <Route path="/bureau/adherents" element={<Navigate to="/adherents" replace />} />
          <Route path="/admin/adherents" element={<GardeOption option="licences" nom="Adhérents"><AdminAdherentsPage /></GardeOption>} />
          <Route path="/boutique" element={<BoutiquePage />} />
          <Route path="/bureau/boutique" element={<GardeOption option="boutique" nom="Boutique"><BureauBoutiquePage /></GardeOption>} />
          <Route path="/admin/boutique" element={<GardeOption option="boutique" nom="Boutique"><AdminBoutiquePage /></GardeOption>} />
          {/* L'ancienne adresse circule dans des signets et dans d'anciens
              e-mails d'affectation : elle redirige plutôt que de laisser une
              page vide. La chaîne de requête suit, sans quoi le raccourci
              « Bureau » de l'accès rapide perdrait son filtre. */}
          <Route path="/bureau/benevoles" element={<RedirectionMembres />} />
          <Route path="/bureau/facturation" element={<BureauFacturationPage />} />
          <Route path="/bureau/encaissements" element={<EncaissementsPage />} />
          <Route path="/bureau/archives" element={<BureauArchivesPage />} />
          <Route path="/bureau/exercices/:id/completion" element={<ExerciceCompletionPage />} />
          {/* Le repertoire : quatre populations, une seule question — « quel est son numero ? ». */}
          <Route path="/repertoire" element={<Navigate to="/repertoire/association" replace />} />
          <Route path="/repertoire/association" element={<RepertoirePage volet="association" />} />
          <Route path="/repertoire/adherents" element={<RepertoirePage volet="adherents" />} />
          {/* Le volet fournisseurs a sa propre page : il ne derive plus des achats. */}
          <Route path="/repertoire/fournisseurs" element={<FournisseursPage />} />
          <Route path="/repertoire/sponsors" element={<RepertoirePage volet="sponsors" />} />
          {/* La bibliotheque : ce qui survit au changement de bureau. */}
          <Route path="/bureau/documents" element={<DocumentsPage />} />
          {/* Les guides livres avec le logiciel : a lire ici, ou a emporter. */}
          <Route path="/guides" element={<DocumentationPage />} />
          {/* Ecrire a un groupe, sans recopier d'adresses a la main. */}
          <Route path="/bureau/diffusion" element={<DiffusionPage />} />
          <Route path="/bureau/campagnes" element={<GardeOption option="festival" nom="Festival"><CampagnePage /></GardeOption>} />
          <Route path="/bureau/festival" element={<GardeOption option="festival" nom="Festival"><FestivalPage /></GardeOption>} />
          <Route path="/bureau/festival/:onglet" element={<GardeOption option="festival" nom="Festival"><FestivalPage /></GardeOption>} />
          <Route path="/bureau/assurance" element={<GardeOption option="assurance" nom="Assurances"><AssurancePage /></GardeOption>} />
          <Route path="/bureau/assurance/:onglet" element={<GardeOption option="assurance" nom="Assurances"><AssurancePage /></GardeOption>} />
          <Route path="/bureau/diffusion/modeles" element={<ModelesMessagePage />} />
          <Route path="/bureau/reunions" element={<BureauReunionsPage />} />
          <Route path="/bureau/reunions/:id" element={<BureauReunionsPage />} />
          {/* Le QR du convive porte cette adresse : la scanner avec
              l'appareil photo mene au meme ecran que depuis la PWA. */}
          <Route path="/retrait-repas" element={<RetraitRepasPage />} />
          <Route path="/retrait-repas/:token" element={<RetraitRepasPage />} />
          <Route path="/bureau/evenements" element={<BureauEvenementsPage />} />
          <Route path="/bureau/evenements/:id" element={<BureauEvenementDetailPage />} />
          {/* La feuille du soir : une journee, poste par poste, sur un telephone. */}
          <Route path="/bureau/evenements/:id/jour-j" element={<JourJPage />} />
          {/* L'adresse disait « mon espace » alors que l'écran ne porte que
              les missions, et « Mon espace » est ailleurs. L'ancien chemin
              redirige : il circule dans des e-mails d'affectation. */}
          <Route path="/mes-missions" element={<BenevolePage />} />
          <Route path="/mon-espace-benevole" element={<Navigate to="/mes-missions" replace />} />

          {/* Anciennes adresses de l'interface Twig, retirée. Le bureau a des
              signets : les rediriger vers l'écran React correspondant vaut
              mieux qu'une page vide. `replace` évite de piéger le bouton
              Retour sur l'adresse morte. */}
          <Route path="/admin" element={<Navigate to="/bureau/tableau-de-bord" replace />} />
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />
          <Route path="/admin/evenements/*" element={<Navigate to="/bureau/evenements" replace />} />
          <Route path="/admin/membres/*" element={<Navigate to="/bureau/membres" replace />} />

          {/* Toute autre adresse inconnue ramène à l'accueil plutôt que de
              laisser un écran blanc sans explication. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </div>

        {/* La signature de la plateforme, au bas de chaque page : elle suit
            le contenu dans le défilement — jamais en travers de l'écran. */}
        <footer className="mt-auto pt-10 pb-24 lg:pb-6 px-4 text-center text-xs text-gray-400 dark:text-gray-500">
          Made with <span className="text-red-500" aria-hidden="true">♥</span> by MAGT —{' '}
          <a
            href="https://shop.gest-asso.com/"
            target="_blank"
            rel="noopener"
            className="underline hover:text-primary-600 dark:hover:text-primary-400"
          >
            Testez moi gratuitement
          </a>
          {/* La version que sert cet espace : c'est la première chose que
              demande le support, et elle mène au journal des livraisons. */}
          <span className="mx-1.5 opacity-50" aria-hidden="true">·</span>
          <Link to="/admin/version" className="hover:text-primary-600 dark:hover:text-primary-400">
            v{VERSION}
          </Link>
        </footer>
      </motion.div>
    </AnimatePresence>
  );
}

/**
 * Les écrans qui prennent toute la largeur.
 *
 * POURQUOI IL Y A UNE EXCEPTION
 * ---------------------------------------------------------------------------
 * La coque plafonne le contenu à 1152 px, et c'est juste pour presque tout :
 * un formulaire, une liste, un texte se lisent mal sur trois mille pixels de
 * large — l'œil perd la ligne en revenant à gauche.
 *
 * La fiche complète d'un adhérent n'est ni l'un ni l'autre. C'est un TABLEAU
 * DE BORD : dix blocs courts, chacun avec son titre et son icône, qu'on repère
 * plutôt qu'on ne lit. La serrer à 1152 px lui donne, sur quatre colonnes, des
 * cases de deux cent soixante-dix pixels — où un montant passe sous son
 * libellé, ce qui est exactement ce qu'on voulait éviter.
 *
 * COMMENT C'EST DÉCIDÉ
 * ---------------------------------------------------------------------------
 * Par l'adresse, ici, plutôt que par chaque page. Une page ne peut pas
 * élargir un conteneur qui lui est extérieur : elle peut demander 1600 px,
 * la coque en rendra 1152, et la largeur écrite dans la page ne servira
 * jamais — ce qui est exactement ce qui s'est produit.
 *
 * La liste est écrite, et courte. Elle le restera : un écran de plus qui
 * réclame la pleine largeur est un écran de plus dont il faut se demander
 * s'il est vraiment un tableau de bord.
 */
const PLEINE_LARGEUR = [
  /^\/adherents\/\d+$/,
];

function App() {
  /*
   * L'adresse décide de la largeur.
   *
   * useLocation plutôt qu'une lecture de window.location : la navigation est
   * côté client, et window.location.pathname ne provoquerait aucun rendu au
   * changement de page — la largeur resterait celle de l'écran précédent.
   */
  const { pathname } = useLocation();
  const largeurContenu = PLEINE_LARGEUR.some((motif) => motif.test(pathname))
    ? 'max-w-none'
    : 'max-w-6xl';

  // Applique les couleurs choisies par le comité : Tailwind compile ses
  // utilitaires en variables CSS, les redéfinir repeint tout le site.
  const perso = usePersonnalisation();

  // L'onglet du navigateur porte le nom de l'association : la coquille
  // statique n'a qu'un titre générique, chaque instance affiche le sien.
  useEffect(() => {
    if (perso?.nomAssociation) {
      document.title = perso.nomAssociation;
    }
  }, [perso?.nomAssociation]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* En essai, chaque écran porte le ruban : les chiffres sont
          d'entraînement, et personne ne doit pouvoir l'oublier. */}
      <RubanDemo />

      {/* Un espace qui n'accepte plus de saisie le dit avant qu'on saisisse.
          Le serveur refusait déjà les écritures et disait pourquoi, mais au
          moment du refus : on l'apprenait en perdant ce qu'on venait
          d'écrire. */}
      <BandeauExploitation />

      {/* Le retour en haut de page : un seul bouton pour les deux mises en
          page. Il est fixe, et retrouve de lui-meme le conteneur qui defile
          — qui n'est pas la fenetre mais un element interne. */}
      <RetourEnHaut />

      {/* Layout mobile : pleine largeur, header + bottom nav */}
      <div className="lg:hidden min-h-screen flex flex-col max-w-md mx-auto bg-white dark:bg-gray-900 shadow-2xl">
        <Header />
        {/* En colonne : la page remplit l'écran et le pied se cale en bas,
            même quand le contenu est court. */}
        <main className="flex-1 relative flex flex-col">
          <AnimatedRoutes />
        </main>
        <BottomNav />
      </div>

      {/* Layout desktop : sidebar + contenu plein écran */}
      <div className="hidden lg:flex min-h-screen">
        <DesktopNav />
        <main className="flex-1 min-h-screen relative bg-gray-50 dark:bg-gray-900">
          <div>
            {/* min-h-full + colonne : le pied de page atteint le bas de la
                fenêtre même quand la page est courte. */}
            <div
              className={`${largeurContenu} mx-auto px-8 py-8 w-full min-h-full flex flex-col`}
            >
              <AnimatedRoutes />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
